import { render, staticRenderFns } from "./header-items-sm-md.vue?vue&type=template&id=b2f6c1a4&scoped=true&"
import script from "./header-items-sm-md.vue?vue&type=script&lang=js&"
export * from "./header-items-sm-md.vue?vue&type=script&lang=js&"
import style0 from "./header-items-sm-md.vue?vue&type=style&index=0&id=b2f6c1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f6c1a4",
  null
  
)

export default component.exports